import { HStack } from '@chakra-ui/react';
import { useResendListingReportShareLinkMutation } from '@client/graphql/__generated__/main-operations';
import { PublicUserFragment } from '@client/graphql/__generated__/types';
import { useLocation } from 'react-router';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { useAppContext } from '~/services/main/contexts/AppContext';
import { ListingPageContent } from '../../components/Listings/ListingPage/ListingPageContent/ListingPageContent';
import {
  ListingPageContext,
  ListingPageProvider,
} from '../../components/Listings/ListingPage/ListingPageContext';
import { SharedPageContext } from '../../contexts/SharedPageContext';
import { useRegisteredRoles } from '../../hooks/useRegisteredRoles';
import { SharedPage } from '../SharedPage/SharedPage';

export const SharedListingPage = () => {
  const { user } = useAppContext();
  const { isRegisteredAgent } = useRegisteredRoles();
  const location = useLocation();
  const [resendListingReportShareLink, { loading }] =
    useResendListingReportShareLinkMutation();

  const resendLink = async (token: string) => {
    await resendListingReportShareLink({ variables: { token } });
  };

  const isPreview = location.pathname.includes('preview') && isRegisteredAgent;

  const listingPage = (sharedBy?: PublicUserFragment) => (
    <ListingPageProvider isViewOnly={true} sharedBy={sharedBy}>
      <HStack
        alignItems="center"
        backgroundColor="bg.main"
        flexGrow={0}
        gap={0}
        minWidth="100vw"
        mx="auto"
      >
        <ListingPageContext.Consumer>
          {({ isLoadingListing }) => {
            return isLoadingListing ? (
              <CenterSpinner />
            ) : (
              <ListingPageContent />
            );
          }}
        </ListingPageContext.Consumer>
      </HStack>
    </ListingPageProvider>
  );

  return isPreview ? (
    listingPage(user as PublicUserFragment)
  ) : (
    <SharedPage isResendingLink={loading} resendLink={resendLink}>
      <SharedPageContext.Consumer>
        {({ sharedBy }) => listingPage(sharedBy)}
      </SharedPageContext.Consumer>
    </SharedPage>
  );
};
